
import { supabase } from "@/integrations/supabase/client";
import { logger } from "@/services/LoggingService";

const COMPONENT = 'UpdateFundImage';

export async function updateFundImage(fundId: string, imageUrl: string | null) {
  logger.info(COMPONENT, 'Starting image update', {
    fundId,
    imageUrl,
    timestamp: new Date().toISOString()
  });

  if (!fundId) {
    const error = new Error("No fund ID provided");
    logger.error(COMPONENT, 'Invalid fund ID', {
      error: error.message,
      fundId
    });
    throw error;
  }

  const { data, error } = await supabase
    .from('funds')
    .update({ fund_image_url: imageUrl })
    .eq('id', fundId)
    .select()
    .single();

  if (error) {
    logger.error(COMPONENT, 'Database operation failed', {
      error: error.message,
      details: error,
      fundId,
      imageUrl
    });
    throw error;
  }

  logger.info(COMPONENT, 'Image updated successfully', {
    fundId,
    imageUrl
  });

  return data;
}
